export function offset(el, parent) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = parent ? parent.scrollLeft : window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = parent ? parent.scrollTop : window.pageYOffset || document.documentElement.scrollTop;
    return {top: rect.top + scrollTop, left: rect.left + scrollLeft};
}

export function triggerEvent($el, eventName, data) {
    let event = new CustomEvent(eventName, {
        detail: data
    });
    $el.dispatchEvent(event);
}

export function toggleBodyScroll(doLock) {
    if (doLock) {
        let _cacheScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        document.body.dataset['scrollTop'] = `${_cacheScrollTop}`;
        document.body.style.top = -_cacheScrollTop + 'px';
        document.body.classList.add('no-scroll');
    } else {
        let _cacheScrollTop = parseFloat(document.body.dataset['scrollTop']||'0');

        document.body.classList.remove('no-scroll');
        document.body.style.top = '';
        window.scrollTo(0, _cacheScrollTop);
    }
}

export function storageAvailable(type) {
    try {
        let storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return false;
    }
}

export function getFromTemplate(htmlString) {
    let div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
}

export function checkVerticalresize(previousWidth, callback) {
    if (previousWidth !== window.innerWidth) {
        if (typeof callback === 'function') {
            callback();
        }
    }
}

export function getHeight($element, fullClassname, timeout = 200, callback) {
    let height;

    $element.classList.add(fullClassname);
    $element.classList.add('no-animation');
    height = $element.offsetHeight;
    if (typeof callback === 'function') {
        callback($element);
    }
    $element.classList.remove(fullClassname);
    setTimeout(() => {
        $element.classList.remove('no-animation');
    }, timeout);

    return height;
}
